import {
  Checkbox,
  FormControlLabel,
  makeStyles,
  Typography
} from '@material-ui/core'
import { FC } from 'react'

const useStyles = makeStyles({
  checkbox: {
    textAlign: 'left',
    '& svg': {
      width: '0.9em',
      height: '0.9em'
    },
    '& label span': {
      fontSize: '11px !important',
      color: 'rgb(102, 102, 102)'
    },
    '& a': {
      color: 'rgb(102, 102, 102)'
    }
  },
  error: {
    display: 'block',
    marginTop: '-4px',
    fontSize: '11px',
    color: 'red'
  }
})

export const CheckboxField: FC<any> = ({ label, input, meta, ...props }) => {
  const styles = useStyles()

  return (
    <div className={styles.checkbox}>
      <FormControlLabel
        control={
          <Checkbox
            checked={input.value ? true : false}
            onChange={input.onChange}
            onBlur={input.onBlur}
          />
        }
        label={label}
      />
      {meta.touched && meta.error && (
        <Typography variant='body1' className={styles.error}>
          {meta.error}
        </Typography>
      )}
    </div>
  )
}
